<template>
  <div class="sq-player-wrap">
    <div @click="play2pause" :style="{width:width,height:height}"
    :class="{'kplayer': playerClass,'aplayer': !playerClass}"  :ref="playerName"></div>
    <!-- <div v-show="pauseShow" class="pauseHide flex_center" @click="pause2play">
    <i class="dd-iconfont  icon-bofang"></i></div> -->
  </div>
</template>
<script>
export default {
  name: 'YPlayer',
  props: {
    immediate: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: 'auto',
    },
    playerName: {
      type: String,
      default: 'yplayer',
    },
    videoUrl: {
      type: String,
      default: '',
    },
    pauseShow: {
      type: Boolean,
      default: !1,
    },
  },
  data() {
    return {
      options: {
        preload: 'metadata',
        video: {
          url: '',
        },
        hotkey: !0,
        mutex: true, // 互斥，阻止多个播放器同时播放，当前播放器播放时暂停其他播放器
        autoplay: false,
        vertical: true,
        theme: '#409EFF',
        quality: !1,
        setting: false,
        playbackRates: [1.5, 1.25, 1, 0.75], // speed
        highlight: false,
        fullscreen: {
          full: true,
          fullweb: true,
        },
        endpanel: {
          feedbackBtn: false,
          replayBtn: true,
        },
        feedback: false,
        userInfo: {},
        socket: false,
      },
    };
  },
  methods: {
    pause2play() {
      // this.$emit('pause2play')
    },
    play2pause() {
      // this.$emit('play2pause')
    },
    fullScreen() {
      // DPlayer监听不到视频退出全屏事件;
      // this.on();
      // const { dp } = this;
      setTimeout(() => {
        // dp.fullscreen();
        // dp.play();
      }, 300);
    },
  },
  created() {
    // this.options.video.url = this.videoUrl
  },
  mounted() {
    const that = this;

    // this.options.video.url = {...this.videoUrl}
    if (this.$route.path === '/amt-web/question') {
      this.options.video.url = this.videoUrl;
    }
    console.log('YPlayer-data', this.options);

    this.options.container = this.$refs[`${this.playerName}`];

    const vm = this;
    // eslint-disable-next-line func-names
    this.yplayer = new window.YPlayer(this.options, function () {
      this.on('playing', () => {
        // const isFullScreen = document.fullscreenElement || document.mozFullScreenElement
        // || document.webkitFullscreenElement || document.msFullscreenElement;
        // if (!isFullScreen) this.fullscreen();
        vm.$emit('update: pauseShow', !1);
        // console.log('视频播放中')
        vm.$emit('playNow');
      });
      this.on('pause', () => {
        vm.$emit('update: pauseShow', !0);
        console.log('视频暂停');
        vm.$emit('paused');
      });

      this.on('ended', () => {
        vm.$emit('update: pauseShow', !0);
        // console.log('视频播放结束')
        vm.$emit('playFinish');
      });
      this.on('fullscreen_cancel', () => {
        console.log('fullscreen_cancel');
        try {
          that.hideVideo();
        } catch (e) {
          console.log('vide: ', e);
        }
      });
      that.fullScreen();
    });
  },
  computed: {
    playerClass() {
      return this.playerName === 'knowledge';
    },
  },
  watch: {
    videoUrl(newV, oldV) {
      // alert(newV, oldV);
      this.options.video.url = newV;
      console.log(oldV, newV);
    },
  },
  beforeDestroy() {
    // console.log(this)
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/study/base.scss";

  .sq-player-wrap{
    position: relative;
    .pauseHide{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity:0.4;
      i{
        color: #fff;
        font-size: 150px;
      }

    }
    // /deep/ .dplayer-mobile{
    //   /deep/ .dplayer-controller {
    //     /deep/ .dplayer-icons{
    //       /deep/ .dplayer-play-icon{display: none;}
                /deep/ .dplayer-icon-content{
                  position: relative;
                  top: -5px;
                }
                /deep/ .dplayer-icons-right{
                  display: flex;
                }
                /deep/ .dplayer-volume-icon{
                  position: relative;
                  top: -2px;
                }
    //     }
    //   }
    // }

  }
</style>
